<!--
  @Description 附件上传
  @Date 2022-01-04
  @Author liushuo
  1.相同日期的附件相同（弃用）
  2.根据当前问题的提出日期作为过滤的条件（弃用）
  3.2022-09-08 改为单行对应附件
-->
<template>
  <el-drawer
    title="附件上传"
    :visible.sync="attachmentDisplay"
    direction="btt"
    size="30%"
    :before-close="handleClose"
    @opened="opened"
    @closed="closed"
  >
    <!-- <div class="toolBox">
      <el-button
        size="small"
        type="primary"
        :disabled="!$parent.specialAuthority.super"
        @click="handleOpenFile"
        >点击上传</el-button
      >
    </div> -->
    <vxe-grid
      ref="xTable"
      size="mini"
      :column-config="{ minWidth: '80px' }"
      border
      keep-source
      :height="tableHeight"
      resizable
      show-overflow
      highlight-hover-row
      highlight-current-row
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        enterToTab: true,
        isClip: true
      }"
      :mouse-config="{ area: true, extension: true }"
      :data="tableData"
      :empty="'false'"
      :columns="gridColumns"
    >
    </vxe-grid>

    <!-- 生成进度框 -->
    <vxe-modal v-model="showProress" title="进度" :showHeader="false" height="50" size="mini">
      <el-progress
        :text-inside="true"
        :stroke-width="26"
        :percentage="percentage"
        :format="processformat"
      ></el-progress>
    </vxe-modal>
    <!-- 选择文件夹 -->
    <input type="file" ref="uploadExcel" v-show="false" id="open" multiple="multiple" @change="uploadFile" />
    <!-- <imgModal ref="imgModal" :imgBase64Arr="imgBase64Arr"></imgModal> -->
  </el-drawer>
</template>

<script>
import { BASEURL } from '@/axios/baseUrlConfig.js'
import { MessageBox } from 'element-ui'
// import imgModal from './AttachmentDrawerImgModal'
export default {
  props: {
    // 是否打开
    attachmentDisplay: {
      type: Boolean,
      default: false
    },
    // 主键值
    keyValue: {
      type: Number,
      default: 0
    },
    // 是否可编辑
    edit: {
      type: Boolean,
      default: false
    },
    parentObj: Object
  },
  components: {
    // imgModal
  },
  data() {
    return {
      // 列头
      gridColumns: [],
      // 是否显示进度
      showProress: false,
      // 当前显示进度字符串
      processStr: '',
      // 进度百分比
      percentage: 0,
      txtOpinion: '',
      tableData: [],
      // 预览图片flag
      imgFlag: false,
      imgBase64Arr: [],
      // 当前选中行的提出日期（弃用）
      // curSelectDate: '',
      // ---- 按nginx进行上传的方式 -----
      rowId: -1,
      attachRowIdList: [],
      // 总上传数量
      fileCount: 0,
      // 上传完成信息
      completeList: [],
      // 上传信息
      arrayUpload: []
    }
  },
  created() {
    this.InitColumn()
  },
  methods: {
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [
        { type: 'seq', width: '45' },
        // 超级权限才能删除
        {
          field: 'delete',
          visible: this.$parent.specialAuthority.super,
          title: '删除',
          width: '50',
          align: 'align:',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.handleDelete(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          title: '下载',
          align: 'center',
          width: '50',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  class='el-icon-download'
                  onClick={() => {
                    this.handleDown(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          field: 'fileName',
          title: '文件名',
          slots: {
            default: ({ row, column }) => {
              return [
                <el-link onClick={() => this.getFileUrl(row)} type='primary'>
                  {row[column.property] + row['extension']}
                </el-link>
              ]
            }
          }
        },
        { field: 'fileURL', title: '路径', visible: false },
        // { field: 'aSize', title: '文件大小' },
        // { field: 'aeName', title: '上传人' },
        { field: 'createDate', title: '所属日期', formatter: 'formatDate' }
      ]
    },
    // 打开附件上传弹窗
    async opened() {
      if (this.keyValue) {
        const { data: res } = await this.$http.get('/Base/BAttachment', {
          params: {
            id: this.rowId
          }
        })
        if (res.isSuccess) {
          this.tableData = res.data
        } else {
          MessageBox({
            message: res.errorMessage,
            type: 'error',
            title: '提示'
          })
        }
      } else {
        this.tableData = []
      }

      this.$refs.xTable.resetColumn()
      this.tableColumns = this.$refs.xTable.getTableColumn().fullColumn
      // 是否显示删除列
      this.tableColumns.forEach(column => {
        if (['delete'].includes(column.property)) {
          column.visible = this.edit
        }
      })
      this.$refs.xTable.refreshColumn()
    },
    // 获取当前资源的静态路径并预览
    async getFileUrl(row) {
      let that = this
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const { data: res } = await that.$http.get(`/Base/BAttachment/secret`, {
        params: {
          link: `${upload}/download/${row.fileURL}`
        }
      })
      // res 是返回的资源路径
      this.openPreviewWindow(res)
    },
    openPreviewWindow(url) {
      // 全屏显示
      var width = window.screen.availWidth
      var height = window.screen.availHeight
      window.open(url, '', `width=${width},height=${height},location=no,status=no`)
    },
    async closed() {
      this.$parent.refresh()
    },
    // 转换base64
    blobToDataURI(blob, callback) {
      let reader = new FileReader()
      reader.onload = e => {
        callback(e.target.result)
      }
      reader.readAsDataURL(blob)
    },
    // 打开文件
    handleOpenFile() {
      this.$refs.uploadExcel.click()
    },
    // 关闭前更新显示状态
    handleClose() {
      this.$emit('update:attachmentDisplay', false)
    },
    /**
     * 上传
     */
    async uploadFile(event) {
      let that = this
      if (this.attachRowIdList.length > 0) {
        // that.fileCount = event.target.files.length
        if (event.target.files.length === 0) {
          return
        }
        // 限制只能上传一个
        that.fileCount = 1
        that.completeList = []
        that.arrayUpload = []
        that.percentage = 0
        that.processStr = `${that.percentage}%`
        // for (let fileObj of event.target.files) {
        // that.uploadSingle(fileObj)
        // }
        that.uploadSingle(event.target.files[0])
      }
      event.target.value = ''
    },
    // 上传一个文件
    uploadSingle(fileObj) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const that = this
      const guID = that.guid()
      let formData = new FormData()
      formData.append('file', fileObj)
      formData.append('vuePathName', '')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN',
          'loading': false
        },
        timeout: 0
      }
      that.$http
        .post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
        .then(({ data: res }) => {
          if (res.isSuccess) {
            that.completeList.push(res.data)
            if (that.completeList.length === that.fileCount) {
              that.writeToDB()
            }
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(err => {
          that.$message.error(err)
        })
      let timer = setInterval(async () => {
        let { data: res } = await that.$http.get(`${upload}/api/progress?X-Progress-ID=${guID}`, {
          headers: { loading: false }
        })
        res = res.replace('(', '')
        res = res.replace(')', '')
        res = res.replace(';', '')
        res = JSON.parse(res)
        if (res.state === 'uploading') {
          let pre = 100
          if (res.size > 0) {
            pre = res.received / res.size
            pre = (pre * 100).toFixed(2)
            if (res.received < res.size && pre === 100) {
              pre = 99.99
            }
          }
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = pre
          }
          that.pre()
        } else {
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = 100
          }
          that.pre()
          clearInterval(timer)
        }
      }, 1000)
      that.arrayUpload.push({ guID: guID, timer: timer, pre: 0 })
      setTimeout(() => {
        if (that.percentage < 100) {
          that.showProress = true
        }
      }, 500)
    },
    // 计算总进度
    pre() {
      let that = this
      let sumPre = this.$utils.sum(that.arrayUpload, 'pre')
      that.percentage = sumPre / that.fileCount
      that.processStr = `${that.percentage}%`
    },
    // 写入应用服务器
    async writeToDB() {
      let that = this
      that.arrayUpload.forEach(item => {
        if (item.timer) {
          clearInterval(item.timer)
        }
      })
      const fileList = that.attachRowIdList.map(id => {
        const temp = {
          ykCaseID: id,
          createDate: new Date(),
          fileURL: that.completeList[0].aPath,
          fileName: that.completeList[0].aDisplay
        }
        return temp
      })
      // const fileList = that.completeList.map((item) => {
      //   const temp = {
      //     ykCaseID: this.rowId,
      //     createDate: new Date(),
      //     fileURL: item.aPath,
      //     fileName: item.aDisplay,
      //   }
      //   return temp
      // })
      const { data: res } = await that.$http.post(`/Base/BAttachment/bulk-insert/`, fileList)
      if (res.isSuccess) {
        that.$message.success('上传成功')
        that.$parent.refresh()
        that.opened()
      } else {
        that.$message.error(res.errorMessage)
      }
      that.percentage = 100
      that.completeList = []
      that.arrayUpload = []
      that.showProress = false
    },
    // 上传（旧方式：根据日期上传）
    // async uploadFile(event) {
    //   let that = this
    //   if (!this.$parent.specialAuthority.super) {
    //     return
    //   }
    //   let length = event.target.files.length
    //   if (length === 0) {
    //     return
    //   }
    //   that.showProress = true
    //   let count = 0
    //   that.processStr = `${count}/${length}`
    //   that.percentage = 0
    //   for (let fileObj of event.target.files) {
    //     let formData = new FormData()
    //     formData.append('file', fileObj)
    //     let config = {
    //       headers: { 'Content-Type': 'multipart/form-data' },
    //       timeout: 60000 * 30,
    //     }

    //     const { data: res } = await that.$http.post(
    //       `/Base/BAttachment/upload/${this.curSelectDate}`,
    //       formData,
    //       config
    //     )
    //     if (res.isSuccess) {
    //       count = count + 1
    //       that.percentage = Number(((100 * count) / length).toFixed(0))
    //       that.processStr = `${count}/${length}`
    //       if (count === length) {
    //         setTimeout(() => {
    //           that.$message.success('上传成功')
    //           that.opened()
    //           that.showProress = false
    //         }, 1000)
    //       }
    //     } else {
    //       that.$messagebox('上传失败')
    //       that.showProress = false
    //       return
    //     }
    //   }
    //   event.target.value = ''
    // },
    // 删除
    handleDelete(row) {
      MessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let that = this
          const { data: res } = await that.$http.delete(`/Base/BAttachment/${row.id}`)
          if (res.isSuccess) {
            that.$message.success('删除成功')
            that.opened()
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(() => {})
    },
    // 下载
    async handleDown(row) {
      let that = this
      await that.$http
        .get(`/Base/BAttachment/download?id=${row.id}`, {
          responseType: 'blob',
          timeout: 60000 * 30
        })
        .then(res => {
          if (res.status === 200) {
            const eleLink = document.createElement('a')
            // TODO 看是否能下载 fileURL
            eleLink.download = row.fileName + row.extension
            eleLink.style.display = 'none'
            eleLink.href = window.URL.createObjectURL(res.data)
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
          }
        })
    },
    // 进度格式化
    processformat() {
      return this.processStr
    },
    guid() {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }
      return guid
    }
  },
  computed: {
    vuePathName() {
      return this.$route.params.vueName
    },
    router() {
      let menu = JSON.parse(JSON.stringify(this.$store.state.menulist))
      let path = this.$route.path

      for (let item of menu) {
        for (let subItem of item.children) {
          for (let i of subItem.children) {
            if ('/' + i.md5Path === path) {
              return i.path
            }
          }
        }
      }
      return ''
    },
    tableHeight() {
      return this.$store.state.clientHeight * 0.3 - 40 + 'px'
    }
  }
}
</script>

<style lang="less" scoped>
.toolBox {
  margin-bottom: 5px;
  padding: 0 0 0 5px;
}
.select {
  margin-left: 10px;
  margin-right: 10px;
}
:focus {
  outline: 0;
}
/deep/ .el-drawer__header {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 5px;
  padding: 5px 10px 0;
}

/deep/ .vxe-body--row {
  height: 40px !important;
}
</style>
